import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { FieldWorkerStoreModel } from './field-worker.reducer';

export enum FieldWorkerActionTypes {
	FieldWorkersRequested = '[Job Assignments Page] FieldWorkers Requested',
	LoadFieldWorkers = '[FieldWorker] Load FieldWorkers',
	AddFieldWorker = '[FieldWorker] Add FieldWorker',
	UpsertFieldWorker = '[FieldWorker] Upsert FieldWorker',
	JobAssignmentsAddFieldWorkers = '[Job Assignments Page] Add FieldWorkers',
	UpsertFieldWorkers = '[FieldWorker] Upsert FieldWorkers',
	UpdateFieldWorker = '[FieldWorker] Update FieldWorker',
	UpdateFieldWorkers = '[FieldWorker] Update FieldWorkers',
	DeleteFieldWorker = '[FieldWorker] Delete FieldWorker',
	DeleteFieldWorkers = '[FieldWorker] Delete FieldWorkers',
	ClearFieldWorkers = '[FieldWorker] Clear FieldWorkers',
	UpdateSearchText = '[Job Assignments Page] Update Search Text',
	UpdateOnlyAvailableRwics = '[Job Assignments Page] Update Only Available Rwics',
	UpdateSelectedTeamId = '[Job Assignments Page] Update Selected Team Id',
}

export class FieldWorkersRequested implements Action {
	readonly type = FieldWorkerActionTypes.FieldWorkersRequested;
	constructor(public payload: { typeId: number; statusId: number }) {}
}

export class LoadFieldWorkers implements Action {
	readonly type = FieldWorkerActionTypes.LoadFieldWorkers;

	constructor(public payload: { fieldWorkers: FieldWorkerStoreModel[] }) {}
}

export class AddFieldWorker implements Action {
	readonly type = FieldWorkerActionTypes.AddFieldWorker;

	constructor(public payload: { fieldWorker: FieldWorkerStoreModel }) {}
}

export class UpsertFieldWorker implements Action {
	readonly type = FieldWorkerActionTypes.UpsertFieldWorker;

	constructor(public payload: { fieldWorker: FieldWorkerStoreModel }) {}
}

export class AddFieldWorkers implements Action {
	readonly type = FieldWorkerActionTypes.JobAssignmentsAddFieldWorkers;

	constructor(public payload: { fieldWorkers: FieldWorkerStoreModel[] }) {}
}

export class UpsertFieldWorkers implements Action {
	readonly type = FieldWorkerActionTypes.UpsertFieldWorkers;

	constructor(public payload: { fieldWorkers: FieldWorkerStoreModel[] }) {}
}

export class UpdateFieldWorker implements Action {
	readonly type = FieldWorkerActionTypes.UpdateFieldWorker;

	constructor(
		public payload: { fieldWorker: Update<FieldWorkerStoreModel> }
	) {}
}

export class UpdateFieldWorkers implements Action {
	readonly type = FieldWorkerActionTypes.UpdateFieldWorkers;

	constructor(
		public payload: { fieldWorkers: Update<FieldWorkerStoreModel>[] }
	) {}
}

export class DeleteFieldWorker implements Action {
	readonly type = FieldWorkerActionTypes.DeleteFieldWorker;

	constructor(public payload: { id: string }) {}
}

export class DeleteFieldWorkers implements Action {
	readonly type = FieldWorkerActionTypes.DeleteFieldWorkers;

	constructor(public payload: { ids: string[] }) {}
}

export class ClearFieldWorkers implements Action {
	readonly type = FieldWorkerActionTypes.ClearFieldWorkers;
}

export class UpdateSearchText implements Action {
	readonly type = FieldWorkerActionTypes.UpdateSearchText;

	constructor(public payload: { searchText: string }) {}
}

export class UpdateOnlyAvailableRwics implements Action {
	readonly type = FieldWorkerActionTypes.UpdateOnlyAvailableRwics;

	constructor(public payload: { onlyAvailableRwics: boolean }) {}
}

export class UpdateSelectedTeamId implements Action {
	readonly type = FieldWorkerActionTypes.UpdateSelectedTeamId;

	constructor(public payload: { selectedTeamId: number[] }) {}
}

export type FieldWorkerActions =
	| FieldWorkersRequested
	| LoadFieldWorkers
	| AddFieldWorker
	| UpsertFieldWorker
	| AddFieldWorkers
	| UpsertFieldWorkers
	| UpdateFieldWorker
	| UpdateFieldWorkers
	| DeleteFieldWorker
	| DeleteFieldWorkers
	| ClearFieldWorkers
	| UpdateSearchText
	| UpdateOnlyAvailableRwics
	| UpdateSelectedTeamId;
